import { render } from "./LpnPendingStorage.vue?vue&type=template&id=bfb6915c"
import script from "./LpnPendingStorage.vue?vue&type=script&lang=js"
export * from "./LpnPendingStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__